import React from 'react';

export const Enter = (props: React.SVGProps<SVGSVGElement>) => {
   return (
      <svg
         width="28"
         height="28"
         viewBox="0 0 28 28"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
         {...props}
      >
         <path
            d="M7.875 14H19.5417M19.5417 14L16.3333 17.2083M19.5417 14L16.3333 10.7917"
            stroke="currentColor"
            strokeWidth="1.86667"
            strokeLinecap="round"
            strokeLinejoin="round"
         />
         <path
            d="M2.33325 17.5V10.5C2.33325 7.92267 4.42259 5.83334 6.99992 5.83334H20.9999C23.5772 5.83334 25.6666 7.92267 25.6666 10.5V17.5C25.6666 20.0773 23.5772 22.1667 20.9999 22.1667H6.99992C4.42259 22.1667 2.33325 20.0773 2.33325 17.5Z"
            stroke="currentColor"
            strokeWidth="1.86667"
         />
      </svg>
   );
};
